<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        لیست محل های تخلیه
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table
                                        dense
                                        hide-default-footer
                                        height="400"
                                        fixed-header
                                        disable-pagination
                                        multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                >
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
                                            <v-icon
                                                    small
                                                    color="warning"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                        <v-btn title="حذف" @click="delete_item_dialog(item)" outlined small
                                               color="error">
                                            <v-icon
                                                    small
                                                    color="error"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <template  v-slot:item.origin_load="{ item }">
                                        <p v-if="item.origin_load">{{item.origin_load.name}}</p>
                                    </template>


                                    <template v-slot:item.employer_price="{ item }">
                                        {{get_currency(item.employer_price)}}
                                    </template>
                                    <template v-slot:item.driver_price="{ item }">
                                        {{get_currency(item.driver_price)}}

                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن محل تخلیه
                    </v-card-title>
                    <v-card-text>
                        <form>
                            <v-text-field
                                    id="place_code"
                                    dense
                                    @keypress="isNumber"
                                    v-on:keyup.enter="another_focus('place_name')"
                                    v-model="model.code"
                                    label="کد محل تخلیه"/>
                            <v-text-field
                                    id="place_name"
                                    dense
                                    v-model="model.name"
                                    v-on:keyup.enter="another_focus('origin_load')"
                                    label="نام محل تخلیه"/>
                            <v-select
                                    id="origin_load"
                                    dense
                                    :items="origin_loads"
                                    item-text="name"
                                    item-value="id"
                                    v-model="model.origin_load_id"
                                    v-on:keyup.enter="another_focus('place_address')"
                                    label="مبدا بارگیری"/>
                            <v-text-field
                                    id="place_address"
                                    dense
                                    v-model="model.address"
                                    v-on:keyup.enter="focusNext($event)"
                                    label="آدرس"/>
                            <div @keyup.enter="focusNext($event)">
                                <v-currency-field
                                        v-model="model.employer_price"
                                        dense
                                        id="place_employer_price"
                                        suffix="ریال"

                                        label="نرخ حمل کارفرما"
                                />
                            </div>
                            <!--                        <v-text-field-->
                            <!--                                v-model="model.employer_price"-->
                            <!--                                @keypress="isNumber"-->
                            <!--                                dense-->
                            <!--                                id="place_employer_price"-->
                            <!--                                suffix="ریال"-->
                            <!--                                v-on:keyup.enter="another_focus('place_driver_price')"-->
                            <!--                                label="نرخ حمل کارفرما"/>-->
                            <div @keyup.enter="focusNext($event)">

                                <v-currency-field
                                        @keypress="isNumber"
                                        dense
                                        v-model="model.driver_price"
                                        id="place_driver_price"
                                        suffix="ریال"
                                        @keyup.enter="focusNext($event)"
                                        label="نرخ حمل کامیوندار"
                                />
                            </div>
                            <!--                        <v-text-field-->
                            <!--                                @keypress="isNumber"-->
                            <!--                                dense-->
                            <!--                                v-model="model.driver_price"-->
                            <!--                                id="place_driver_price"-->
                            <!--                                suffix="ریال"-->
                            <!--                                v-on:keyup.enter="another_focus('place_summary')"-->
                            <!--                                label="نرخ حمل کامیوندار"/>-->
                            <v-text-field v-if="status_form==0"
                                          v-model="model.summary"
                                          dense
                                          id="place_summary"
                                          v-on:keyup.enter="another_focus('add_place')"
                                          label="توضیحات"/>
                            <v-text-field v-if="status_form!=0"
                                          v-model="model.summary"
                                          dense
                                          id="place_summary"
                                          v-on:keyup.enter="another_focus('edit_place')"
                                          label="توضیحات"/>
                        </form>

                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_place" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="edit_place" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'

    import {bus} from '../main'

    export default {
        name: 'OriginDownload',
        components: {},
        data() {
            return {
                confirm_delete_name: "confirm_delete" + new Date().getTime() + "_" + this.$vnode.tag,
                items: [],
                origin_loads: [],
                status_form: 0,
                model: {
                    code: '',
                    name: '',
                    address: '',
                    employer_price: '',
                    driver_price: '',
                    summary: '',
                },
                headers: [
                    {
                        text: 'کد',
                        value: 'code'
                    },
                    {
                        text: 'نام محل تخلیه',
                        value: 'name'
                    },
                    {
                        text: 'نام مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'آدرس محل تخلیه',
                        value: 'address'
                    },
                    {
                        text: 'نرخ حمل کارفرما',
                        value: 'employer_price'
                    },
                    {
                        text: 'نرخ حمل کامیوندار',
                        value: 'driver_price'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ]
            }
        },
        mounted() {
            this.get_origin_load()
            this.get_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        },
        methods: {
            reset_form() {
                this.model = {
                    code: '',
                    name: '',
                    address: '',
                    employer_price: '',
                    origin_load_id: 0,
                    driver_price: '',
                    summary: '',
                }
                this.status_form = 0
            },
            edit_item(item) {
                this.model = JSON.parse(JSON.stringify(item))
                this.status_form = item.id
            },
            get_data() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_origin_load() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.origin_loads = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            insert_data() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/discharge_places/insert'
                if (this.status_form != 0) {
                    url = '/api/discharge_places/update'
                    formData.append('id', this.status_form)
                }
                formData.append('code', this.model.code)
                formData.append('name', this.model.name)
                if (this.model.address == null) {
                    this.model.address = "";
                }
                if (this.model.summary == null) {
                    this.model.summary = "";
                }
                formData.append('address', this.model.address)
                formData.append('employer_price', this.model.employer_price)
                formData.append('driver_price', this.model.driver_price)
                formData.append('summary', this.model.summary)
                if(this.model.origin_load_id==0){
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا مبدا بارگیری را انتخاب کنید')
return
                }
                formData.append('origin_load_id', this.model.origin_load_id)

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal("هشدار", "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
                this.status_form = item.id;

            },
            delete_item() {
                const self = this;
                const formData = new FormData()
                const url = '/api/discharge_places/delete';
                formData.append('id', this.status_form);

                this.axios.post(url, formData, {}).then((res) => {

                    if (res.data.error == 0) {
                        self.$root.modal_component.show_api_response_modals(res);
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', res.data.msg)
                    }
                    self.status_form = 0;

                    self.get_data();


                })
                    .catch(function (error) {
                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }
</script>
